import { render, staticRenderFns } from "./EventStat.vue?vue&type=template&id=3f43e18d&"
import script from "./EventStat.vue?vue&type=script&lang=ts&"
export * from "./EventStat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports